<template>
  <div class="distro-page max-container">
    <div class="distro-page-inner">
      <DistroInfo :in-stock-only="inStockOnly" :never-ordered="neverOrdered" @update:inStockOnly="inStockOnly = $event"
        @update:neverOrdered="neverOrdered = $event" />
      <BrandListItem :in-stock-only="inStockOnly" :never-ordered="neverOrdered" />
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import DistroInfo from "./modules/DistroInfo.vue";
import BrandListItem from "./modules/BrandListItem.vue";
import Auth from "@/modules/Auth";

export default {
  name: "DistroPage",
  components: {
    DistroInfo,
    BrandListItem,
  },
  setup() {
    const { verifyUser } = Auth();
    const inStockOnly = ref(false);
    const neverOrdered = ref(false);

    verifyUser();

    return {
      inStockOnly,
      neverOrdered,
    };
  },
};
</script>

<style lang="scss" scoped>
.distro-page {
  @apply w-full pb-10;

  .distro-page-inner {
    @apply lg:w-full space-y-7;
  }
}
</style>
